import { WebViewerInstance } from '@pdftron/webviewer'

export const redactionAnnotationProperties = {
    author: 'Fictiv',
    customData: { isFictiv: true, userName: 'Redaction' },
}

type RedactionProps = {
    page: number
    x: number
    y: number
    boundingBox: {
        xmax: number
        xmin: number
        ymax: number
        ymin: number
    }
}

export const configureRedaction = (
    instance: WebViewerInstance,
    attachmentId: string,
) => {
    const { Annotations } = instance

    class RedactionAnnotation extends Annotations.RedactionAnnotation {
        constructor(props: RedactionProps) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super('RedactionAnnotation')
            this.setCustomData(
                'isFictiv',
                redactionAnnotationProperties.customData.isFictiv,
            )

            this.setCustomData(
                'userName',
                redactionAnnotationProperties.customData.userName,
            )
            this.Author = redactionAnnotationProperties.author
            this.PageNumber = props.page
            this.X = props.x
            this.Y = props.y
            this.setCustomData('boundingBox', props.boundingBox)
            this.setCustomData('attachmentId', attachmentId)
            this.setRect(
                new instance.CoreControls.Math.Rect(
                    props.boundingBox.xmin,
                    props.boundingBox.ymin,
                    props.boundingBox.xmax,
                    props.boundingBox.ymax,
                ),
            )
            this.StrokeColor = new Annotations.Color(74, 74, 255)
            this.FillColor = new Annotations.Color(255, 255, 255)
            this.StrokeThickness = 2
        }
    }

    return RedactionAnnotation
}
